(function(){
  "use strict";

  angular.module('irricrops')
    .controller('loginCtrl', ['$rootScope', '$scope', '$location', '$localStorage', 'Auth','menu','urls','$http','$stateParams', "$state","temporadaFac","$q",
      function ($rootScope, $scope, $location, $localStorage, Auth, menu, urls, $http, $stateParams, $state, temporadaFac, $q){

        var vm       = this;
        vm.submited  = false;
        vm.user      = {};
        vm.wrongPass = false;
        vm.loading   = false;

        //http://www.toptal.com/web/cookie-free-authentication-with-json-web-tokens-an-example-in-laravel-and-angularjs

        var successAuth = function(res) {
          $localStorage.token = res.token;

          var url = null;
          if($stateParams.url !== undefined){
            url = window.location.origin+"/#" +$stateParams.url;
          }

          if($location.$$host === urls.PRODUCTION_HOST_NAME){
            mixpanel.people.increment("veces logeado");
            mixpanel.track("login", {}, function(){



              menu.clean();

              menu.getMe().then(() => {
                return  temporadaFac.getTemporadas();
              }).then(function(){
                menu.getSidebarProm();
                $state.go('initial').then(function(){
                  if(url !== null){
                    window.location = url;
                  }
                });
              });


            });
          }else{


            menu.clean();
            menu.getMe({reload:true})
              .then(() => {
              return temporadaFac.getTemporadas(true);
            })
            .then(function(){
                if(url !== null){
                  window.location = url;
                }
            });


          }
        };

        var errorAuth = function(res) {
          vm.wrongPass = true;
          vm.loading = false;
        };

        vm.signin = function () {
          vm.submited= true;
          vm.loading = true;
          vm.wrongPass = false;
          var formData = {
            email: vm.user.email,
            password: vm.user.password
          };

          Auth.signin(formData, successAuth, errorAuth);
        };

        // vm.signup = function () {
        //     var formData = {
        //         email: vm.email,
        //         password: vm.password
        //     };
        //
        //     Auth.signup(formData, successAuth, function () {
        //         $rootScope.error = 'Failed to signup';
        //     })
        // };

        // // @deprecated
        //  vm.logout_dep = function () {
        //      Auth.logout(function () {
        //        mixpanel.track("logout");
        //          if (mixpanel.cookie && mixpanel.cookie.clear) {
        //            mixpanel.cookie.clear();
        //            //window.clearInterval(id);
        //          }
        //          //window.location = "/";
        //
        //          var url = window.location.href;
        //          url = url.split("#")[1];
        //          $state.go("login", {
        //            url: url
        //          });
        //      });
        //  };

        vm.token = $localStorage.token;
        vm.tokenClaims = Auth.getTokenClaims();

      }]);

})();
